import { useTheme } from 'styled-components';
/**
 * This hook uses size tokens and returns the appropriate CSS object for the CloseButton.
 *
 * @param variantTokens - Object that contains the necessary variant tokens for idle, hover, active, and disabled.
 *
 * @returns A new CSS Object that returns the appropriate styles.
 */
export const useVariantCssObject = variantTokens => {
  const theme = useTheme();
  return {
    display: 'block',
    backgroundColor: theme.color[variantTokens.idle.backgroundColor],
    borderRadius: theme.borderRadius['button-radius-circle'],
    borderWidth: theme.borderWidth['button-default'],
    color: theme.color[variantTokens.idle.color],
    width: 'fit-content',
    '&:hover:not([aria-disabled="true"])': {
      backgroundColor: theme.color[variantTokens.hover.backgroundColor],
      color: theme.color[variantTokens.hover.color]
    },
    '&:active:not([aria-disabled="true"])': {
      backgroundColor: theme.color[variantTokens.active.backgroundColor],
      color: theme.color[variantTokens.active.color]
    },
    '&[aria-disabled="true"]': {
      backgroundColor: theme.color[variantTokens.disabled.backgroundColor],
      color: theme.color[variantTokens.disabled.color],
      cursor: variantTokens.disabled.cursor
    }
  };
};

/**
 * This hook uses size tokens and returns the appropriate CSS object for the CloseButton.
 *
 * @param sizeTokens - Object that contains the padding & iconSize of the CloseButton.
 *
 * @returns A new CSS Object that returns the appropriate padding.
 */
export const useSizeCssObject = sizeTokens => {
  const theme = useTheme();
  return {
    padding: theme.space[sizeTokens.padding]
  };
};